export const getCleanCityName = (city?: string): string => {
    if (!city) return ''

    const parts = city.split(' ')
    if (parts.length === 1) return parts[0]

    const firstIsNumeric = /^\d+$/.test(parts[0])
    return firstIsNumeric ? parts.slice(1).join(' ') : city
}
